export default __webpack_public_path__ + "static/media/s009.fcefd672.jpeg";